import { StrakitLoadingButtonDirective } from '@ngx-strakit/cdk/directives';

/**
 * @deprecated Use `StrakitLoadingButtonDirective` from `@ngx-strakit/cdk/directives` directly.
 */
export const IrisLoadingButtonDirective = StrakitLoadingButtonDirective;
